module.exports = __webpack_public_path__ + "static/media/banners.f96f7faa.svg";